module.exports = __webpack_public_path__ + "static/sport/bg.87336ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = yEeP
// module chunks = 0